import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@/react/components/SettingsApp/CompassCompat/ConfirmationModal";

interface BlockDmsModalProps {
  isLoading?: boolean;
  memberName: string;
  onClose: () => void;
  onConfirm: () => void;
  showModal: boolean;
}

export const BlockDmsModal = ({
  showModal,
  onClose,
  onConfirm,
  memberName,
  isLoading = false,
}: BlockDmsModalProps) => (
  <ConfirmationModal
    disabled={isLoading}
    isOpen={showModal}
    onClose={onClose}
    confirmVariant="danger"
    size="lg"
    onConfirm={onConfirm}
    title={t("messaging.block_direct_messages_modal.title", {
      name: memberName,
    })}
    confirmText={t("messaging.block_direct_messages_modal.confirm")}
  >
    {t("messaging.block_direct_messages_modal.description", {
      name: memberName,
    })}
  </ConfirmationModal>
);
